import { useRouteParams } from "@vueuse/router";
import { useExperienceMediaQuery } from "../queries/useExperienceMediaQuery";

export function useCurrentExperienceMediaQuery() {
  const idRef = useRouteParams<string>("id");

  const experienceMediaQuery = useExperienceMediaQuery(idRef);

  return experienceMediaQuery;
}
